import day from 'dayjs'
import { contentTypeId } from '@uswitch/ev-utils/lib/contentful'

const getPageDates = includes => {
  const [updated, created] = Object.values(includes).reduce(
    ([updated, created], it) => [
      updated > day(it?.sys?.updatedAt) ? updated : it?.sys?.updatedAt,
      created > day(it?.sys?.createdAt) ? created : it?.sys?.createdAt,
    ],
    [0, 0],
  )

  return { updated, created }
}

export const getUrlDates = ({ includes = {}, items }) => {
  let publishDate
  let updatedDate

  if (items?.[0]?.fields?.url) {
    publishDate = items[0].fields.publishDate
    updatedDate = items[0].fields.updatedDate
  } else {
    const dateFields = Object.values(includes || {}).find(mod => contentTypeId(mod) === 'url')
      ?.fields

    if (dateFields) {
      publishDate = dateFields.publishDate
      updatedDate = dateFields.updatedDate
    }
  }

  if (!publishDate) {
    publishDate = getPageDates(includes).created
  }

  return { publishDate, updatedDate }
}

export const sortByDate = (a, b) => {
  const aDate = new Date(a?.fields?.updatedDate || a?.fields?.publishDate)
  const bDate = new Date(b?.fields?.updatedDate || b?.fields?.publishDate)
  return bDate - aDate
}
